import React from 'react';
import classnames from 'classnames';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { H1 } from 'components/Ui';
import ServiceLocations from 'containers/PrimoAccount/ServiceLocations';
import commonStyles from '../styles.scss';
import styles from './styles.scss';

const Header = () => (
  <div className={styles.container}>
    <div className={classnames(commonStyles.container, styles.innerContainer)}>
      <div>
        <H1 className={styles.label}>My Profile</H1>
      </div>
      <div>
        <ServiceLocations
          darkDropdown
          reloadUrl="/account/profile"
          selectClassName={styles.locationSelect}
        />
      </div>
    </div>
  </div>
);

const mapStateToProps = createStructuredSelector({});

Header.propTypes = {};

export default connect(mapStateToProps)(Header);
